// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"6d755eab","695":"51102d41"}[chunkId] + ".chunk.css";
};